import React from 'react';
import styled from 'styled-components';
import { getUserRights } from "../../api";
import { getCtaVariant } from '@utils/abTestCookies.js';
import { LoginContext } from "../login/context/LoginContext";
import { TailwindWrapper } from '@utils/TailwindWrapper';
import { cn } from '@utils/cn';
import { TreebulaIcon } from '@ui-component-library/components/Icon/lib';
import { Icon, Text, Button, Link, Sheet, showToast, Toaster } from '@ui-component-library';
import TreebulaLogoText from '@assets/treebula/treebulalogotext.svg'
import TreebulaLogo from '@assets/treebula/treebulalogo.svg'

function mobileOffcanvasAccordionShellClass(isOpen) {
    return cn(
        'grid transition-[grid-template-rows] duration-300 ease-in-out motion-reduce:transition-none md:grid-rows-[1fr]',
        isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
    );
}

class Navigation extends React.Component {
    static contextType = LoginContext;

    constructor() {
        super();

        this.state = {
            isLogged: Window.user_data.isLogged,
            isAdmin: Window.user_data.isAdmin,
            userRoles: Window.user_data.roles,
            showMobileMenu: false,
            dropdownTop: null,
            mobileDropdownOpen: []
        }
        this.navbarRef = React.createRef()
    }

    updateNavbar() {
        getUserRights().then(resp => {
            if (resp.ok) {
                resp.json().then((json) => {
                    this.setState({ isLogged: json.is_login, userRoles: json.roles, isAdmin: json.is_admin })
                })
            }
        }).catch(() => {
            // Silently ignore. Fetch fails expectedly when user navigates away mid-request
        })
    }

    // When the component is mounted, observe the body for class changes to update the navbar
    componentDidMount() {
        // Use the line below to update the navbar in other components:
        // document.getElementsByTagName('body')[0].classList.toggle("nav-update")

        this.observer = new MutationObserver(record => {
            record.forEach((event) => {
                if (event.attributeName == 'class') {
                    this.updateNavbar(); // Trigger update when class changes
                }
            })
        })

        this.observer.observe(document.getElementsByTagName('body')[0], { attributes: true })
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    // Toggle the active dropdown menu
    setActiveMenu(name) {
        const closing = this.state.dropdown === name
        const top = closing ? null : (this.navbarRef.current?.getBoundingClientRect?.()?.bottom ?? null)
        this.setState({ dropdown: closing ? false : name, dropdownTop: top })
    }

    toggleMobileDropdown(name) {
        this.setState((prev) => {
            const open = prev.mobileDropdownOpen.includes(name)
                ? prev.mobileDropdownOpen.filter((n) => n !== name)
                : [...prev.mobileDropdownOpen, name];
            return { mobileDropdownOpen: open };
        });
    }

    userAccountButtons(size = 'md') {
        const LoginContext = this.context;
        const sizes = {
            md: {
                icon: '24px',
                div: '50px'
            },
            sm: {
                icon: '18px',
                div: '32px'
            }
        }

        return <>
            {this.state.isAdmin && <div className="flex justify-center items-center border border-charcoal-500 rounded-full bg-charcoal-500 me-1" style={{ height: sizes[size].div, width: sizes[size].div, cursor: "pointer" }} onClick={() => window.open('/vb-admin/', '_blank')}>
                <img className='primary-core-filter mb-1' src={`${Window.static_path}img/treebula/icon.svg`} alt="admin icon" height={sizes[size].icon} width={sizes[size].icon} />
            </div>}

            <div className={`flex justify-center items-center border border-charcoal-500 rounded-full ${this.state.isLogged ? 'bg-charcoal-500' : 'hover-bg-cloud-500'}`} style={{ height: sizes[size].div, width: sizes[size].div, cursor: "pointer" }} onClick={() => LoginContext.isLogged ? window.open('/min-skog/', '_self') : LoginContext.setShow(true)}>
                <img className={`${this.state.isLogged ? 'primary-core-filter' : ''}`} src={`${Window.static_path}img/icons/user-outline.svg`} alt="user icon" height={sizes[size].icon} width={sizes[size].icon} />
            </div>

        </>
    }

    checkVisible(i, jsx) {
        const { userData } = this.context;

        if (i.visible == 'NO_USER' && userData.is_logged) {
            return null
        }

        if (i.visible == 'ONLY_LOGGED' && !userData.is_logged) {
            return null
        }

        if (i.visible == 'ONLY_PLUS' && !userData.is_plus) {
            return null
        }

        if (i.visible == 'NOT_PLUS' && userData.is_plus) {
            return null
        }

        if (i.visible == 'LOGGED_NOT_PLUS' && (!userData.is_logged || userData.is_plus)) {
            return null
        }

        return jsx
    }

    render() {

        const loginContext = this.context;
        const navCta = getCtaVariant();
        const showDemoButton = navCta === 'demo';
        return <>
            {/* Overlay for the dropdown, hidden unless a dropdown is active */}
            <div className="sticky top-0" style={{ zIndex: 1040 }}>
                    {this.state.dropdown && <div className="hidden xl:block fixed inset-0 bg-transparent z-[var(--z-nav-overlay)]" onClick={() => { this.setState({ dropdown: false, dropdownTop: null }) }}>
                    </div>}
                    {/* Single blurred layer for navbar + dropdown (z-[1071]); solid bg when mobile menu open */}
                    <div className="relative z-[var(--z-nav-bar)] w-full">

                        <div
                            className={`absolute inset-0 ${this.state.showMobileMenu ? 'bg-[#0A0A0A] h-full' : 'bg-[#0A0A0A]/80 backdrop-blur-[32px]'} ${this.state.dropdown ? 'h-[520px]' : 'h-full'}`}         
                            aria-hidden="true"
                        />
                        <div className="relative z-10">
                            <div className='max-w-[1320px] mx-auto py-4 gap-2 flex items-center justify-between px-4'>
                                <div className='flex items-center'>
                                    <a
                                        className='flex items-center gap-2 cursor-pointer no-underline mr-8'
                                        href="/"
                                    >
                                        <TreebulaLogo width="132px" height="21px" className="md:hidden" />
                                        <TreebulaLogoText width="132px" height="21px" className="hidden md:block" />
                                    </a>
                                    <div className="hidden xl:block">
                                        <div className="relative w-full z-[var(--z-nav-links)]" ref={this.navbarRef}>
                                            <div className="flex items-center relative z-[var(--z-nav-items)]">
                                                {Window.navbar_data.map(i => {
                                                    if (i.url != 'dropdown') {
                                                        return this.checkVisible(i,
                                                            <Text variant="text-sm/leading-normal/normal" key={i.label}>
                                                                <Link
                                                                    href={(this.state.isLogged && i.logged_in_url) ? i.logged_in_url : i.url}
                                                                    className="font-normal text-cloud-200 hover:text-white no-underline hover:bg-[rgba(255,255,255,0.08)] hover:no-underline rounded-lg px-4 py-3"
                                                                >
                                                                    {i.label}
                                                                </Link>
                                                            </Text>
                                                        )
                                                    } else {
                                                        return this.checkVisible(i,
                                                            <Button
                                                                variant='tertiary'
                                                                size="medium"
                                                                key={i.name}
                                                                className="font-normal text-cloud-200 hover:bg-[rgba(255,255,255,0.08)]"
                                                                onClick={() => this.setActiveMenu(i.name)}
                                                            >
                                                                {i.label}
                                                                <Icon
                                                                    name="ChevronDownSimple"
                                                                    size="medium"
                                                                    className={`fill-cloud-200 pointer-events-none ${this.state.dropdown == i.name ? 'rotate-180' : ''} transition-transform duration-150`}
                                                                    aria-hidden
                                                                />
                                                            </Button>
                                                        )
                                                    }
                                                })}
                                            </div>
                                            {Window.navbar_data.map((i) => {
                                                if (i.url === 'dropdown' && i.content) {
                                                    return (
                                                        <React.Fragment key={i.name} >
                                                            {this.state.dropdown === i.name && this.state.dropdownTop != null && (
                                                                <div
                                                                    className="hidden xl:block fixed left-0 right-0 z-[var(--z-nav-dropdown-area)] mt-4 bg-transparent"
                                                                    style={{ top: this.state.dropdownTop, minHeight: '380px' }}
                                                                />
                                                            )}
                                                            <div className={`absolute top-full left-0 z-[var(--z-nav-links)] py-6 w-[720px] ${this.state.dropdown === i.name ? "xl:block" : "hidden"}`}>
                                                                <div className="grid grid-cols-2 gap-4">
                                                                    <div className="flex flex-col">
                                                                        {i.content.items.filter(link => link.column != 2).map((link) => {
                                                                            return this.checkVisible(link, (
                                                                                <Link key={link.label} href={(this.state.isLogged && link.logged_in_url) ? link.logged_in_url : link.url} className="font-normal flex flex-col flex-nowrap p-4 my-1 rounded-lg hover:bg-[rgba(255,255,255,0.08)] w-full no-underline hover:no-underline text-inherit">
                                                                                    <div className="flex items-center">
                                                                                        <Text variant="text-base/leading-normal/medium" className="font-medium text-cloud-200 mr-3 hover:text-white">
                                                                                            {link.label}
                                                                                        </Text>
                                                                                        {link.icon && <Icon name={link.icon} size="medium" className="fill-[#c6c6c6] shrink-0 ml-auto " />}
                                                                                    </div>
                                                                                    <div>
                                                                                        <Text variant="text-sm/leading-normal/normal" className='font-normal text-[#c6c6c6] truncate'>{link.subText}</Text>
                                                                                    </div>
                                                                                </Link>
                                                                            ))
                                                                        })}
                                                                    </div>
                                                                    <div className="flex flex-col">
                                                                        {i.content.items.filter(link => link.column == 2).map((link) => this.checkVisible(link, (
                                                                            <Link key={link.label} href={(this.state.isLogged && link.logged_in_url) ? link.logged_in_url : link.url} className="font-normal flex flex-col flex-nowrap p-4 my-1 rounded-lg hover:bg-[rgba(255,255,255,0.08)] w-full no-underline hover:no-underline text-inherit">
                                                                                <div className="flex items-center">
                                                                                    <Text variant="text-base/leading-normal/medium" className="font-medium text-cloud-200 mr-3 hover:text-white">
                                                                                        {link.label}
                                                                                    </Text>
                                                                                    {link.icon && <Icon name={link.icon} size="medium" className="fill-[#c6c6c6] shrink-0 ml-auto " />}
                                                                                </div>
                                                                                <div>
                                                                                    <Text variant="text-sm/leading-normal/normal" className="font-normal text-[#c6c6c6] truncate">{link.subText}</Text>
                                                                                </div>
                                                                            </Link>
                                                                        )))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div className='flex items-center gap-4'>
                                    <div className="hidden md:flex items-center gap-2 sm:gap-4">
                                        {showDemoButton && (
                                            <Button
                                                variant='tertiary'
                                                size="medium"
                                                onClick={() => { window.open('/min-skog/demo/', '_self'); }}
                                                className={
                                                    loginContext.isLogged
                                                        ? 'text-cloud-200 bg-[#515151] hover:bg-[rgba(255,255,255,0.12)]'
                                                        : 'text-cloud-200 hover:bg-[rgba(255,255,255,0.08)]'
                                                }
                                            >
                                                Testa Plus
                                            </Button>
                                        )}
                                        {this.state.isAdmin && <Button variant='tertiary' size="medium" className='text-[#ECFF8C] bg-[#4E5431]' onClick={() => window.open('/vb-admin/', '_blank')}>Admin</Button>}
                                        {!this.state.isAdmin && !this.state.isLogged && <Button variant='tertiary' size="medium" className="text-cloud-200 bg-[#515151]" onClick={() => { if (loginContext.isLogged) window.open('/min-skog/', '_self'); else loginContext.setShow(true); }}>Kom igång</Button>}
                                    </div>
                                    {!this.state.isLogged ? (
                                        <Button variant='tertiary' size="medium" className="bg-[#DFFF5D] text-#0F0F0F hover:bg-[rgba(255,255,255,0.08)]" onClick={() => { if (loginContext.isLogged) window.open('/min-skog/', '_self'); else loginContext.setShow(true); }}>
                                            <Icon name="BankIdSimple" size="medium" className='fill-#0F0F0F' />
                                            Logga in
                                        </Button>
                                    ) : <Button variant='tertiary' size="medium" className='text-[#ECFF8C] bg-[#0A0A0A]/50' onClick={() => { if (loginContext.isLogged) window.open('/min-skog/', '_self'); else loginContext.setShow(true); }}>
                                        Min skog
                                        <Icon name="ArrowRightSimple" size="medium" className='fill-[#ECFF8C]' />
                                    </Button>}
                                    <Button variant='tertiary' className="xl:hidden flex items-center justify-center rounded-lg -mr-2.5 p-3 text-cloud-200 hover:bg-[rgba(255,255,255,0.08)]" onClick={() => this.setState({ showMobileMenu: !this.state.showMobileMenu, mobileDropdownOpen: [] })} aria-label={this.state.showMobileMenu ? 'Stäng meny' : 'Öppna meny'}>
                                        {this.state.showMobileMenu ? (
                                            <Icon name="CrossSimple" size="large" className="fill-cloud-200" />
                                        ) : (
                                            <Icon name="HamburgerMenu" size="large" className="fill-cloud-200 " />
                                        )}
                                    </Button>
                                </div>
                            </div>
                        </div>

                    </div>
                <div className="sticky" style={{ zIndex: 1039, height: 0, overflow: 'hidden' }}>
                    <Toaster position="top-right" />
                </div>
            </div >

            <Sheet isOpen={this.state.showMobileMenu} onClose={() => this.setState({ showMobileMenu: false })} side="left" className="border-0 navbar-mega-menu-fullscreen" style={{ background: '#0A0A0A' }}>
                    <div className="font-nista-grotesk flex flex-col w-full min-h-dvh h-full bg-[#22252A]" >
                        <div className="flex justify-between items-center px-4 py-4 w-full">
                            <a href="/" className="flex items-center gap-2 no-underline" onClick={() => this.setState({ showMobileMenu: false })}>
                                <TreebulaLogo width="132px" height="21px" className="md:hidden" />
                                <TreebulaLogoText width="132px" height="21px" className="hidden md:block" />
                            </a>
                            <Button variant='tertiary' className="p-2 rounded-lg text-cloud-200 hover:bg-[rgba(255,255,255,0.08)]" onClick={() => this.setState({ showMobileMenu: false })} aria-label="Stäng meny">
                                <Icon name="CrossSimple" size="large" className="fill-cloud-200" />
                            </Button>
                        </div>
                        <div className="flex-1 flex flex-col min-h-0">
                            <div className="flex-1 overflow-auto px-4 py-4">
                                
                                {Window.navbar_data.map(i => {
                                    if (i.url !== 'dropdown' || !i.content || !i.content.items) {
                                        return null
                                    };
                                    
                                    const columns = [
                                        i.content.items.filter(link => link.column != 2),
                                        i.content.items.filter(link => link.column == 2),
                                    ];
                                    
                                    const isOpen = this.state.mobileDropdownOpen.includes(i.name);
                                    const toggleOpen = () => this.toggleMobileDropdown(i.name);

                                    const itemBlock = (link) => (
                                        <div key={link.label} className="rounded-xl flex flex-col px-2">
                                            <Link
                                                href={(this.state.isLogged && link.logged_in_url) ? link.logged_in_url : link.url}
                                                className="font-normal flex items-center flex-nowrap p-6 rounded-lg hover:bg-[rgba(255,255,255,0.08)] hover:text-[#D5EE64] w-full text-cloud-200 no-underline  hover:no-underline"
                                                onClick={() => this.setState({ showMobileMenu: false })}
                                            >
                                                <Text variant="text-base/leading-normal/medium" className="font-medium text-cloud-200 min-w-0 flex-1">
                                                    {link.label}
                                                </Text>
                                                {link.icon && <Icon name={link.icon} size="medium" className="fill-[#c6c6c6] shrink-0 ml-2" />}
                                            </Link>
                                            {link.content && (
                                                <Text variant="text-sm/leading-normal/normal" className="font-normal text-[#c6c6c6] pl-2">
                                                    {link.content}
                                                </Text>
                                            )}
                                        </div>
                                    );

                                    return (
                                        <div key={i.name}>
                                            {/* Mobile only: clickable header to expand/collapse */}
                                            <div
                                                role="button"
                                                tabIndex={0}
                                                className="flex md:hidden items-center justify-between cursor-pointer py-1 p-4 rounded-lg hover:bg-white/5"
                                                onClick={toggleOpen}
                                                onKeyDown={(e) => {
                                                    if (e.key !== 'Enter' && e.key !== ' ') {
                                                        return;
                                                    };
                                                    
                                                    e.preventDefault();
                                                    toggleOpen();
                                                }}
                                                aria-expanded={isOpen}
                                                aria-label={`${i.label}, ${isOpen ? 'stäng' : 'öppna'}`}
                                            >
                                                <Text
                                                    as="h4"
                                                    variant="text-base/leading-normal/normal"
                                                    className={cn('p-4 font-normal', isOpen ? 'text-cloud-200' : 'text-cloud-200/80')}
                                                >
                                                    {i.label}
                                                </Text>
                                                <Icon 
                                                    name="ChevronDownSimple" 
                                                    size="medium" 
                                                    aria-hidden
                                                    className={cn(
                                                        'text-cloud-200 transition-transform duration-150', 
                                                        isOpen && 'rotate-180'
                                                        )} 
                                                    />
                                            </div>
                                            <div className="hidden md:block px-8">
                                                <Text variant='text-xs/leading-normal/normal' className="font-normal text-[#c6c6c6]">{i.label}</Text>
                                            </div>
                                            <div className={mobileOffcanvasAccordionShellClass(isOpen)}>
                                                <div className="min-h-0 overflow-hidden">
                                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                        {columns.map((links, columnIndex) => (
                                                            <div key={columnIndex} className="flex flex-col">
                                                                {links.map(link => this.checkVisible(link, itemBlock(link)))}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                                {Window.navbar_data.filter(i => i.url !== 'dropdown').map(i => this.checkVisible(i,
                                    <div key={i.label} className="rounded-xl max-w-[480px] px-2">
                                        <Link
                                            href={(this.state.isLogged && i.logged_in_url) ? i.logged_in_url : i.url}
                                            className="font-normal text-cloud-200 no-underline hover:no-underline block p-6 rounded-lg hover:text-[#D5EE64] hover:bg-[rgba(255,255,255,0.08)]"
                                            onClick={() => this.setState({ showMobileMenu: false })}
                                        >
                                            <Text variant="text-base/leading-normal/normal" className="text-cloud-200">{i.label}</Text>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                            <div className="flex gap-3 px-4 py-4 border-t border-white/10 shrink-0">
                                {!this.state.isLogged ? (
                                    showDemoButton ? (
                                    <Button variant="secondary" size="medium" className="flex-1 text-cloud-200 bg-cloud-200/30 justify-center" onClick={() => { window.open('/min-skog/demo/', '_self'); }}>
                                    Testa Plus
                                </Button>
                                    ) : null
                                ) : (<Button variant="tertiary" size="medium" className="flex-1 text-cloud-200 bg-[#515151] justify-center gap-2" onClick={() => { this.setState({ showMobileMenu: false }); window.location.href = '/logout/'; }}>
                                    Logga ut
                                </Button>)
                                }
                                {!this.state.isLogged ? (
                                    <Button variant="secondary" size="medium" className="flex-1 bg-[#D5EE64] text-[#0F0F0F] justify-center gap-2" onClick={() => { this.setState({ showMobileMenu: false }); if (loginContext.isLogged) window.open('/min-skog/', '_self'); else loginContext.setShow(true); }}>
                                    <Icon name="BankIdSimple" size="large" className="fill-[#0F0F0F]" />
                                    Logga in
                                </Button>
                                ) : (<Button variant="tertiary" size="medium" className="flex-1 justify-center text-[#ECFF8C] bg-[#0A0A0A]/50 " onClick={() => { if (loginContext.isLogged) window.open('/min-skog/', '_self'); else loginContext.setShow(true); }}>Min skog <Icon name="ArrowRightSimple" size="medium" className='fill-[#ECFF8C]' /></Button>)}
                            </div>
                        </div>
                    </div>
            </Sheet>
        </>
    }
}

export default Navigation;